<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input placeholder="请输入手机号" v-model="params.telephone" size="small"></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/lottery/activity/white/add')" type="primary" icon="el-icon-plus" size="small"
                @click="$refs.addRef.show(id)">新增白名单</el-button>
            <el-button v-if="$utils.have('/lottery/activity/white/import')" type="primary" icon="el-icon-upload"
                size="small" @click="$refs.batchImportRef.show(id)">导入白名单</el-button>
            <el-button v-if="$utils.have('/lottery/activity/white/delete') && dataList.length > 0" type="danger"
                icon="el-icon-upload" size="small" @click="del">删除白名单</el-button>
        </div>
        <div class="page-list-box">
            <el-card shadow="never">
                <div class="list-box">
                    <el-checkbox-group v-model="tels">
                        <el-checkbox v-for="(item, index) in dataList" :key="index" :label="item"></el-checkbox>
                    </el-checkbox-group>
                </div>
                <el-empty v-if="data && data.totalCount == 0"></el-empty>
            </el-card>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                layout="total, prev, pager, next" :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <add ref="addRef" @onUpdate="reset"></add>
        <batch-import ref="batchImportRef" @update="reset"></batch-import>
    </div>
</template>

<script>
import Add from './components/add.vue'
import BatchImport from './components/batchImport.vue'
const defaultParams = {
    pageNo: 1,
    lotteryActivityId: "",
    telephone: "",
    pageSize: 100
};
export default {
    props: {
        id: {
            type: [Number, String],
            default: ""
        }
    },
    components: { Add,BatchImport },
    data() {
        return {
            data: null,
            dataList: [],
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                // pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                telephone: this.$route.query.telephone || '',
            },
            listLoading: true,
            tels: []
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/lottery/activity/white/list",
                method: "POST",
                data: {
                    ...this.params,
                    lotteryActivityId: this.id
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //删除
        del() {
            if (this.tels.length == 0) {
                this.$message.warning("请选择要删除的手机号");
                return;
            }
            this.$confirm('确认要删除吗？', '删除', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.$request({
                    url: "/lottery/activity/white/delete",
                    method: "POST",
                    data: {
                        tels: this.tels,
                        lotteryActivityId: this.id
                    }
                }).then(res => {
                    const { state, msg } = res.data;
                    if (state && state == 1) {
                        this.$message.success("删除成功");
                        this.reset()
                    } else {
                        return this.$message.error(msg || "删除失败");
                    }
                })
            }).catch(() => { })
        }
    }
}
</script>

<style lang="scss" scoped>
.list-box {
    .el-checkbox {
        margin: 5px 10px;
    }
}
</style>